import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import FileSize from './FileSize'
import NodeLink from './NodeLink'
import AWS from 'aws-sdk'
import { Progress, message} from 'antd'
import { Spinner } from '../Spinner'
export default class DirectoryListingTable extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        size: PropTypes.number.isRequired
      }).isRequired
    ).isRequired,
    headerSortClasses: PropTypes.shape({
      name: PropTypes.string.isRequired,
      lastModified: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      accessKeyId: PropTypes.string,
      secretAccessKey: PropTypes.string,
      bucket: PropTypes.string
    }).isRequired
  }

  state = {
    flag: false,
    progress: 0
  }

  loading = (dProgress) => {
    
    this.setState({
      progress: dProgress
  })
}

  setflag = () => {
    this.setState({
      flag: !this.state.flag
    })
  }

  render() {
    const {
      items,
      headerSortClasses,
      changeSort,
      accessKeyId,
      secretAccessKey,
      bucket
    } = this.props

    const handleDownload = async (fileName) => {
      if(!fileName) {
        return;
      }
      message.success(" Your download will begin shortly. Please stay tuned.", 2);
      // Replace with the actual file name
      // 
      this.setflag()
      try {
        const blob = await downloadFileAsBlob(fileName, bucket)

        // Create a temporary URL for the blob
        // 
        const url = URL.createObjectURL(blob)

        // Trigger file download
        const link = document.createElement('a')
        link.href = url
        // 
        
        setTimeout(() => {
          // Your code here
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        
        document.body.removeChild(link)
        
        // Clean up the temporary URL
        URL.revokeObjectURL(url)
        
          this.setflag()
          message.success("Success! Your download was completed. Please check your download folder", 5);
          this.setState({
            progress: 0
        })
        }, 1500);
       
        
      } catch (error) {
        console.error('Error downloading file:', error)
        message.error("Error downloading file");
      }
    }

    const downloadFileAsBlob = (fileName, bucketName) => {
      const s3 = new AWS.S3({
        accessKeyId,
        secretAccessKey
      })

      const params = {
        Bucket: bucketName,
        Key: fileName
      }

      return new Promise((resolve, reject) => {
        s3.getObject(params, (err, data) => {
          if (err) {
            message.error("Error downloading file");
            reject(err)
            
          } else {
            const blob = new Blob([data.Body])
            resolve(blob)
            
          }
        }).on('httpDownloadProgress', (progress) => {
          const percentage = (progress.loaded / progress.total) * 100;
          // console.log(`Download Progress: ${percentage.toFixed(2)}%`);
          this.loading(percentage.toFixed(2))
        });
      })
    }

    const rows = items.map((child) => {
      return child.name.length > 0 ? (
        <tr key={child.key}>
          <td onClick={() =>{ if(!child.children) handleDownload(child.key)}}>
            <NodeLink
              node={child}
              accessKeyId={accessKeyId}
              secretAccessKey={secretAccessKey}
              bucket={bucket}
            >
              {child.name}
            </NodeLink>
          </td>
          <td>{child.lastModified.toLocaleString()}</td>
          <td>
            <FileSize size={child.size} />
          </td>
        </tr>
      ) : (
        <></>
      )
    })

    return (
      <div className="objects-table">
        {this.state.flag ? (
          <div>
            <Progress percent={this.state.progress} />
            
              <Spinner percent={this.state.progress} />
              <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 10
              }}
            >
              <b>
                <span> Your download is in progress. Please stay tuned...!</span>
              </b>
            </div>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <td className="column_name">
                  <b>
                    <span>Name</span>
                  </b>
                  <div
                    className={classNames('sort', headerSortClasses.name)}
                    onClick={() => changeSort('name')}
                  />
                </td>
                <td className="column_last-modified">
                  <b>
                    <span>Last Modified</span>
                  </b>
                  <div
                    className={classNames(
                      'sort',
                      headerSortClasses.lastModified
                    )}
                    onClick={() => changeSort('lastModified')}
                  />
                </td>
                <td className="column_size">
                  <b>
                    <span>Size</span>
                  </b>
                  <div
                    className={classNames('sort', headerSortClasses.size)}
                    onClick={() => changeSort('size')}
                  />
                </td>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </table>
        )}
      </div>
    )
  }
}
